import React, { useState, forwardRef, useImperativeHandle } from 'react';
import styled, { css } from 'styled-components';

import { Z_INDEX_LAYER } from '@CommonConstants';

import TX from '../Text';
import Button from '../Button';

const SnackBar = forwardRef((props, ref) => {
  const [visible, setVisible] = useState(false);
  const [text, setText] = useState('');
  const [action, setAction] = useState({});

  const isCancelOwned = Object.keys(action).length;

  useImperativeHandle(ref, () => ({
    show({ text: sbText, action: sbAction = {}, duration = 2500 }) {
      setVisible(true);
      setText(sbText);
      setAction(sbAction);
      setTimeout(() => setVisible(false), duration);
    },
    closeSnackBar() {
      setVisible(false);
    },
  }));

  if (!visible) {
    return null;
  }

  return (
    <SnackBarWrapper>
      <SnackBarInner isCancelOwned={isCancelOwned} width={props.width}>
        <SnackBarText>{text}</SnackBarText>

        {isCancelOwned ? (
          <CancelSnackBarInner>
            <CancelDivider />

            <Button
              text={action.text}
              backgroundColor="transparent"
              onClick={() => {
                action.onClick();
                setVisible(false);
              }}
              style={{ minWidth: '72px' }}
            />
          </CancelSnackBarInner>
        ) : null}
      </SnackBarInner>
    </SnackBarWrapper>
  );
});

const SnackBarWrapper = styled.div`
  position: fixed;
  left: 50%;
  transform: translate(-50%, -50%);
  bottom: 44px;

  z-index: ${Z_INDEX_LAYER.LEVEL_10};
`;

const SnackBarInner = styled.div`
  height: 44px;
  background-color: ${({ theme }) => theme.colors.ui_on_2};
  border-radius: 4px;
  box-shadow: 0px 2px 20px #00000066;

  ${({ isCancelOwned, width }) =>
    isCancelOwned
      ? css`
          display: flex;
          width: ${width && width}px;
          justify-content: space-between;
        `
      : css`
          display: inline-block;
          cursor: none;
        `}
`;

const SnackBarText = styled(TX.FootnoteM)`
  color: ${({ theme }) => theme.colors.ui_1};

  padding: 14px 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const CancelSnackBarInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CancelDivider = styled.div`
  width: 1px;
  height: 24px;
  background-color: #535353;
`;

export default SnackBar;
